module.exports = __webpack_public_path__ + "img/ic_instagram.5c8a88dc.svg";